import { apiFetch } from "./client.js";

export interface Bill {
  rowKey: string;
  partitionKey: string; // kidId
  description: string;
  amountCents: number;
  monthsTotal: number;
  monthsRemaining: number;
  createdAt: string;
}

export async function listBills(kidId: string): Promise<Bill[]> {
  const res = await apiFetch<{ bills: Bill[] }>(`/api/kids/${encodeURIComponent(kidId)}/bills`);
  return res.bills;
}

export async function createBill(
  kidId: string,
  body: { description: string; amountCents: number; monthsTotal: number },
): Promise<Bill> {
  return apiFetch<Bill>(`/api/kids/${encodeURIComponent(kidId)}/bills`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function deleteBill(kidId: string, billId: string): Promise<void> {
  await apiFetch<{ ok: true }>(
    `/api/kids/${encodeURIComponent(kidId)}/bills/${encodeURIComponent(billId)}`,
    { method: "DELETE" },
  );
}
